export default "__VITE_ASSET__824db154__"